<template>
  <div>
    <button class="cancel-button md:md-cancel-button" v-on:click="reset()">
      Exit Game
    </button>
  </div>
</template>

<script>
export default {
  name: 'CancelButton',
  methods: {
    reset() {
      this.$store.commit('reset');
    },
  },
};
</script>

<style>
.cancel-button {
  border-radius: 25px 25px 0 0;
  bottom: 0;
  background-color: #e0dfdf;
  color: #fff;
  font-size: .75rem;
  font-weight: 500;
  height: 8vw;
  left: 2.5vw;
  position: absolute;
  text-transform: uppercase;
  width: 32vw;
}

@responsive {
  .md-cancel-button {
    height: 3vw;
    font-size: 1.5rem;
    width: 12vw;
  }
}
</style>
